"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiResultAdapter = exports.ApiFormatType = void 0;
var core_1 = require("@moralisweb3/core");
// TODO: make part of core config? The challenge in that case is to make sure it is Typed correctly
var ApiFormatType;
(function (ApiFormatType) {
    // Return the data directly, as is provided by the API
    ApiFormatType["RAW"] = "raw";
    // Return the formatted result of all moralis DataTypes
    ApiFormatType["JSON"] = "JSON";
    // Return class with moralis DataTypes and format functions
    ApiFormatType["NORMAL"] = "normal";
})(ApiFormatType = exports.ApiFormatType || (exports.ApiFormatType = {}));
/**
 * The adapter for the API result.
 */
var ApiResultAdapter = /** @class */ (function () {
    function ApiResultAdapter(data, adapter, jsonAdapter, params) {
        this.data = data;
        this.adapter = adapter;
        this.jsonAdapter = jsonAdapter;
        this.params = params;
    }
    Object.defineProperty(ApiResultAdapter.prototype, "raw", {
        /**
         * @returns a raw data from the API.
         */
        get: function () {
            return this.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiResultAdapter.prototype, "result", {
        /**
         * @returns the result adapted into SDK types.
         */
        get: function () {
            return this.adapter(this.data, this.params);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @returns the result in the JSON format.
     */
    ApiResultAdapter.prototype.toJSON = function () {
        return this.jsonAdapter(this.result);
    };
    /**
     * Format the result to a specific format.
     */
    ApiResultAdapter.prototype.format = function (formatType) {
        if (formatType === ApiFormatType.RAW) {
            return this.raw;
        }
        if (formatType === ApiFormatType.JSON) {
            return this.toJSON();
        }
        if (formatType === ApiFormatType.NORMAL) {
            return this.result;
        }
        throw new core_1.MoralisApiError({
            code: core_1.ApiErrorCode.GENERIC_API_ERROR,
            message: 'provided formatType not supported',
        });
    };
    return ApiResultAdapter;
}());
exports.ApiResultAdapter = ApiResultAdapter;
//# sourceMappingURL=ApiResultAdapter.js.map